export default __webpack_public_path__ + "static/media/follow2.2dd4e38a.svg";